import { useMemo } from "react";

const bars = (seed, n) => {
  let x = [...(seed || "x")].reduce((a, c) => a * 31 + c.charCodeAt(0), 7) % 2147483647;
  return Array.from({ length: n }, (_, i) => {
    x = (x * 16807) % 2147483647;
    const env = 0.55 + 0.45 * Math.sin((i / n) * Math.PI);
    return { id: `${seed}-${i}`, v: 0.2 + (x / 2147483647) * 0.8 * env };
  });
};

export const Waveform = ({ seed, progress = 0, onSeek, n = 90, className = "h-10", testId }) => {
  const data = useMemo(() => bars(seed, n), [seed, n]);
  const click = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    onSeek?.((e.clientX - r.left) / r.width);
  };
  return (
    <div data-testid={testId} onClick={click} className={`flex items-center gap-[2px] cursor-pointer group ${className}`}>
      {data.map(({ id, v }, i) => (
        <span key={id} className="flex-1 rounded-full transition-colors duration-150"
          style={{ height: `${v * 100}%`, background: i / n < progress ? "var(--c-orange)" : "#3a3a4c" }} />
      ))}
    </div>
  );
};
